var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-qa":"popup-layout-body"}},[_vm._t("prepend"),_vm._v(" "),(_vm.hasBody())?_c('div',{class:_vm.$style.body},[_c('div',{class:[
        _vm.$style.main,
        { [_vm.$style.fullWidth]: _vm.singleColumn },
        { [_vm.$style.clearPadding]: _vm.paddingDisabled }
      ]},[_vm._t("main")],2),_vm._v(" "),(!_vm.singleColumn)?_c('div',{class:_vm.$style.side},[_vm._t("side")],2):_vm._e()]):_vm._e(),_vm._v(" "),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }